import styled from 'styled-components';

export const Recipe = styled.div`
  background: white;
  min-height: 100%;
`
